import { render } from "./map-dttj2.vue?vue&type=template&id=508cc4c4"
import script from "./map-dttj2.vue?vue&type=script&lang=js"
export * from "./map-dttj2.vue?vue&type=script&lang=js"

import "./map-dttj2.vue?vue&type=style&index=0&id=508cc4c4&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__